import { render } from "./password-set.vue?vue&type=template&id=91c3c8b8"
import script from "./password-set.vue?vue&type=script&lang=js"
export * from "./password-set.vue?vue&type=script&lang=js"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__